import * as _ from "lodash";
import * as angular from "angular";
import { ConsentType } from "../../models/consent-type.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { ConsentTypeDataProvider } from "../../data-provider/consent-type.dp";

let CreateConsentTypeComponent = {
    selector: "vcCreateConsentType",
    templateUrl:
        "/angular/components/consent-type/create-consent-type.component.html",
    bindings: {},
    controller: class CreateConsentTypeController {
        public isOrganisationType: boolean;
        public search = "";
        public defaults = [
            new ConsentType({ name: "Marketing" }),
            new ConsentType({ name: "Volunteer Updates" }),
            new ConsentType({ name: "Account Updates" }),
            new ConsentType({ name: "Helpdesk Updates" }),
            new ConsentType({ name: "Newsletter Updates" }),
        ];
        public consentTypes: ConsentType[];

        private dialog: DialogUtils;
        public dataProvider: ConsentTypeDataProvider;

        constructor(
            DialogUtils: DialogUtils,
            ConsentTypeDataProvider: ConsentTypeDataProvider,
            __app_type: string
        ) {
            this.isOrganisationType = __app_type == "LEADER";
            this.dataProvider = ConsentTypeDataProvider;
            this.dialog = DialogUtils;

            this.dataProvider.all().then((consentTypes) => {
                let consentTypeSuggestions = this.defaults.filter((item) => {
                    for (const consentType of consentTypes) {
                        if (consentType.name === item.name) {
                            return false;
                        }
                    }
                    return true;
                });
                this.consentTypes = _.cloneDeep(consentTypeSuggestions);
            });
        }

        filterConsentTypes(query): ConsentType[] {
            return query && query !== ""
                ? this.consentTypes.filter((obj) => {
                      return (
                          obj["name"]
                              .toLowerCase()
                              .indexOf(query.toLowerCase()) !== -1
                      );
                  })
                : this.consentTypes;
        }

        cancel(): void {
            this.dialog.cancel();
        }

        save(consentType): void {
            if (!consentType || this.search != consentType.name) {
                consentType = { name: this.search };
            }
            this.dialog.hide(consentType);
        }
    },
};

angular
    .module("consentType")
    .component(CreateConsentTypeComponent.selector, CreateConsentTypeComponent);
